import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';

import { GrupoClassificacaoSituacaoSelectComponent } from './select';
import { GrupoClassificacaoSituacaoMultiselectComponent } from './multiselect';
import { GrupoClassificacaoSituacaoBadgeComponent } from './badge';
import { GrupoClassificacaoSituacaoPipe, GrupoClassificacaoSituacaoBadgePipe } from './pipes';

@NgModule({
    imports: [
        SharedModule,
        NgxBootstrapMultiselectModule
    ],
    declarations: [
        GrupoClassificacaoSituacaoSelectComponent,
        GrupoClassificacaoSituacaoMultiselectComponent,
        GrupoClassificacaoSituacaoBadgeComponent,

        // Pipes
        GrupoClassificacaoSituacaoPipe,
        GrupoClassificacaoSituacaoBadgePipe
    ],
    exports: [
        GrupoClassificacaoSituacaoSelectComponent,
        GrupoClassificacaoSituacaoMultiselectComponent,
        GrupoClassificacaoSituacaoBadgeComponent,

        // Pipes
        GrupoClassificacaoSituacaoPipe,
        GrupoClassificacaoSituacaoBadgePipe
    ],
    providers: [
        GrupoClassificacaoSituacaoPipe,
        GrupoClassificacaoSituacaoBadgePipe
    ]
})
export class GrupoClassificacaoSituacaoModule { }
